define('views/parts/popup/activation-link',[
    'underscore', 'backbone', 'mustache', 'utils',
    // templates
    'text!templates/parts/popup/activation-link.html',
], function(
    _, Backbone, Mustache, U,
    // templates
    TActivationLinkPopup
) {

    /**
     * Encapsulates default options to create a VMenu with pills nav style.
     */
    var VActivationLinkPopup = Backbone.View.extend({
        template: TActivationLinkPopup,

        initialize: function(opt) {
            this.options = opt || {};
            this.options = _.extend({
                alreadyActiveMessage: 'messages:message-member-already-active',
            }, opt);

            this.view = {};
        },

        render: function() {
            var html = Mustache.render(this.template, Mustache.getContext(this.options));

            return html; // Chaining view calls, good convention http://backbonejs.org/#View-render
        },

        copyLink: function() {
          document.querySelector("#validation-link-input").select();
          document.execCommand('copy');
        }

    });

    return VActivationLinkPopup;
});

